enum UserPatchType {
  TransferUser = 'TRANSFER_USER',
  UpdateOwner = 'UPDATE_OWNER',
  GeneralPatch = 'GENERAL_PATCH',
}

export default UserPatchType;
